// extracted by mini-css-extract-plugin
module.exports = {"whats_new":"WhatsNew_whats_new_1etJx","title":"WhatsNew_title_GYpGF","news_area":"WhatsNew_news_area_Ee38d","slideNews":"WhatsNew_slideNews_QWGji"};